import ModalSectionView from "../../../modal/view/section.js";

import {
  CLOSE_BUTTON_TEXT,
  MODAL_HEADING_TEXT,
  MODAL_DESCRIPTION,
  LINK_TEXT,
  BUTTON_TEXT
} from "../../lexicon.js";

const createModalSectionTemplate = () => {
  return (
    `<section class="share-cart-modal-section">
      <button class="share-cart-modal-close-button">
        <span class="visually-hidden">${CLOSE_BUTTON_TEXT}</span>
      </button>
      <div class="share-cart-modal">
        <h3 class="heading heading_h3 share-cart-modal-heading">${MODAL_HEADING_TEXT}</h3>
        <p class="share-cart-modal__text">${MODAL_DESCRIPTION}</p>
        <a class="share-cart-modal-link">${LINK_TEXT}</a>
        <button class="button button_share-cart-copy">${BUTTON_TEXT}</button>
      </div>
    </section>`
  );
};


export default class ModalShareCartSection extends ModalSectionView {
  constructor() {
    super();

    this._closeButtonClass = `share-cart-modal-close-button`;
    this._createModalSectionTemplate = createModalSectionTemplate;

    this._linkElement = null;
    this._copyLinkButton = null;

    this._copyLinkButtonClickHandler = this._copyLinkButtonClickHandler.bind(this);
  }

  getSlideElement() {
    if (!this._slideElement) {
      this._slideElement = this._element.closest(`.share-cart-modal-wrapper .fancybox__slide`);
    }

    return this._slideElement;
  }

  getLinkElement() {
    if (!this._linkElement) {
      this._linkElement = this._element.querySelector(`.share-cart-modal-link`);
    }

    return this._linkElement;
  }

  getCopyLinkButton() {
    if (!this._copyLinkButton) {
      this._copyLinkButton = this._element.querySelector(`.button_share-cart-copy`);
    }

    return this._copyLinkButton;
  }

  applyLink(uri) {
    this.getLinkElement().href = uri;
  }

  setCopyLinkButtonClickHandler(callback) {
    this._callback.copyLinkButtonClick = callback;
    this.getCopyLinkButton().addEventListener(`click`, this._copyLinkButtonClickHandler);
  }

  _copyLinkButtonClickHandler() {
    this._callback.copyLinkButtonClick();
  }
}
